import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

interface Props extends ChakraV3.StackProps {
  orientation?: 'horizontal' | 'vertical';
}

export const FormStack = (props: React.PropsWithChildren<Props>) => {
  const { orientation, children, ...rest } = props;

  const direction = (orientation ?? 'vertical') === 'horizontal' ? 'row' : 'column';

  return (
    <ChakraV3.Stack w='full' h='full' gap={4} direction={direction} {...rest}>
      {children}
    </ChakraV3.Stack>
  );
};
